import { createContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Modal, { ModalSize } from "src/components/Modal";

export const ModalViewContext = createContext({
	isModal: false,
	title: "",
	setTitle: (title: string) => {},
	setOnClose: (cb: () => void) => {},
	onClose: () => {},
});

// type Modify<T, R> = Omit<T, keyof R> & R;

export type ModalElementProps = {
	onClose?: () => void;
	backUrl: string;
	expanded?: boolean;
	size: ModalSize;
	className?: string;
};

type ModalState = {
	title?: string;
	onClose?: () => void;
};

interface ModalViewProps {
	children?: any;
	visible: boolean;
	modal: ModalElementProps;
}

const ModalView = ({ children, visible: _visible, modal }: ModalViewProps) => {
	const [visible, setVisible] = useState(_visible);
	const [modalState, setModalState] = useState<ModalState>();
	const navigate = useNavigate();
	const location = useLocation();
	const back = location?.state?.back;

	const handleClose = () => {
		if (!visible) return;
		setVisible(false);

		setTimeout(() => {
			if (modalState?.onClose) {
				modalState.onClose();
			}
			if (modal?.onClose) {
				modal.onClose();
				return;
			}
			if (back?.to) {
				navigate(back.to);
				return;
			}
			if (modal?.backUrl) {
				navigate(modal?.backUrl);
			}
		}, 600);
	};

	return (
		<ModalViewContext.Provider
			value={{
				isModal: true,
				title: modalState?.title || "",
				setTitle: (title: string) =>
					setModalState((state: any) => ({
						...state,
						title,
					})),
				setOnClose: (cb: () => void) =>
					setModalState((state: any) => ({
						...state,
						onClose: cb,
					})),
				onClose: handleClose,
			}}
		>
			<Modal {...modal} {...{ visible }} onClose={handleClose}>
				{children}
			</Modal>
		</ModalViewContext.Provider>
	);
};

export default ModalView;
